import _ from 'lodash/fp';

const getGroupedTerms = (termsAndConditions) =>
  _.flow(
    _.flatten,
    _.reject((entry) => _.isEmpty(entry) || _.isEmpty(entry.disclaimers)),
    _.groupBy('title'),
    _.map((entries) => ({
      ...entries[0],
      disclaimers: _.flow(_.map('disclaimers'), _.flatten)(entries),
    })),
  )(termsAndConditions);

export default getGroupedTerms;
